import React from "react";
import PropTypes from "prop-types";
import {Collapse, Card, CardBody, CardHeader, Button} from "reactstrap";
import {SlArrowUp, SlArrowDown} from "react-icons/sl";

const Accordion = ({title, content, isOpen, onToggle}) => {
  return (
    <Card style={{border: "none"}}>
      <CardHeader style={{padding: "0.5rem 1.25rem", border: "none"}}>
        <Button
          onClick={onToggle}
          className="shadow d-flex justify-content-between w-100"
          style={{
            backgroundColor: isOpen ? "#f7fafc" : "white",
            fontSize: "large",
            border: "1px solid #d3d3d3",
          }}
          data-cy="accordion-btn"
        >
          <span>{title}</span>
          <span>
            {isOpen ? (
              <SlArrowUp data-cy="arrow-up" />
            ) : (
              <SlArrowDown data-cy="arrow-down" />
            )}
          </span>
        </Button>
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody data-cy="accordion-content">{content}</CardBody>
      </Collapse>
    </Card>
  );
};

Accordion.propTypes = {
  /** Wether accordion is open */
  isOpen: PropTypes.bool.isRequired,
  /** Callback function which will be executed on toggle */
  onToggle: PropTypes.func.isRequired,
  /** Title of accordion */
  title: PropTypes.string.isRequired,
  /** Content of accordion */
  content: PropTypes.node.isRequired,
};

export default Accordion;
